import * as React from "react";
import { createModule } from "../config.js";
import { EventsProvider, TimeoutsProvider } from "../contexts/index.js";
export var Core = function Core(_ref) {
  var children = _ref.children;
  return React.createElement(TimeoutsProvider, null, React.createElement(EventsProvider, null, children));
};
export var CoreModule = createModule("core", Core);